// extracted by mini-css-extract-plugin
export default {"picker":"src-feature-ui-__color-picker_picker","color":"src-feature-ui-__color-picker_color"};